module.exports = __webpack_public_path__ + "static/media/no-signal.1d835b06.svg";